import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';

import CustomText from '../../../styles/CustomText';
import useQwalletServer from '../../../hooks/useQwalletServer';
import useSecureStorage from '../../../hooks/useSecureStorage';

import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { BounceLoader } from "react-spinners";
import { getTelegramId } from '../../../utils/telegramClientData';


const WalletCreationLoading: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	const { t } = useTranslation();

	const { getNetworkWalletAddress } = useSecureStorage()
	const { updateAirdropWalletAddress } = useQwalletServer()

	useEffect(() => {
		const generateWallet = async () => {
			try {
				// 게임 airdrop 주소 BSC 지갑주소로 업데이트
				const walletAddress = await getNetworkWalletAddress(process.env.REACT_APP_AIRDROP_ADDRESS_NETWORK_NAME?.toLowerCase() || '')
				const telegramId = await getTelegramId()
				if(walletAddress && true === await updateAirdropWalletAddress(walletAddress, telegramId)) {
					setTimeout(() => {
						navigate(`/WalletCreationComplete`, { replace: true, state: { } });
					}, 2000)
				} else {
					alert('Error update airdrop wallet address')
					// 첫 화면으로 이동
					setTimeout(() => {
						navigate(`/CreateWallet`, { replace: true, state: { } });
					}, 2000)
				}
			} catch (error) {
				console.error('Error update airdrop wallet address:', error)
			}
		}

		generateWallet()
	}, [])

	const styles = {
		container: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: "150px"
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0",
		} as React.CSSProperties,
		subTitle1: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties,
		subTitle2: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.container}>
				<div style={{ marginBottom: "10px" }}>
					<BounceLoader color={"blue"} size={100} />
				</div>

				<CustomText weight="medium" style={{ ...styles.title}}>
					{t('wallet_creation_completed_message_01')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle1}}>
					{t('wallet_creation_completed_message_02')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle2}}>
					{t('wallet_creation_completed_message_03')}
				</CustomText>
			</div>
		</div>
	)
}

export default WalletCreationLoading
